import { JSX, useEffect, useRef } from 'react';
import {
  LinkField,
  Link,
  Text,
  Field,
  Image,
  ImageField,
  RichText,
} from '@sitecore-jss/sitecore-jss-nextjs';
import { StyleguideComponentProps } from 'lib/component-props';
import { classNames } from 'assets/utils/helper';
import { getMarginSize } from 'assets/utils/getMarginSize';
import { observeInView } from 'src/hooks/observeInView';

type LinkListParentProps = StyleguideComponentProps & {
  fields: {
    MarginSize: {
      fields: {
        heading: {
          value: string;
        };
      };
    };
    BaseHeadline: Field<string>;
    BaseDescription: Field<string>;
    BaseImage: ImageField;
    BaseLinks: Array<LinkListChildProps>;
    WhiteBackground?: Field<boolean | string>;
  };
};

type LinkListChildProps = {
  fields: {
    BaseURL: LinkField;
  };
};

const LinkList = (props: LinkListParentProps): JSX.Element => {
  const marginSize = getMarginSize(
    props?.fields?.MarginSize?.fields?.heading?.value
  );
  const animRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (!animRef.current) return;

    observeInView(animRef.current);
  }, []);

  if (!props || !props.fields || !props.fields.BaseLinks) {
    return <div></div>;
  }
  const isWhiteBg =
    props.fields.WhiteBackground?.value === true ||
    props.fields.WhiteBackground?.value === '1' ||
    props.fields.WhiteBackground?.value === 'true';
  return (
    <div
      className={classNames('overhauled', marginSize)}
      id={`link-list-${props.rendering?.uid}`}
    >
      <div
        className={`link-list ${isWhiteBg ? 'base' : 'bg-primary'} inner-vertical-spacing`}
      >
        <div className="jss-inner-container">
          <div
            className={
              props.fields?.BaseImage?.value?.src
                ? 'inner-container with-img'
                : 'inner-container'
            }
          >
            {props.fields.BaseImage?.value?.src && (
              <div className="desktop">
                <div className="img-container">
                  <Image field={props.fields.BaseImage} />
                </div>
              </div>
            )}
            <div className="content-wrapper">
              {props.fields.BaseHeadline?.value && (
                <Text
                  className="heading"
                  tag="h2"
                  field={props.fields.BaseHeadline}
                />
              )}
              {props.fields.BaseDescription?.value && (
                <RichText
                  className="description"
                  tag="p"
                  field={props.fields.BaseDescription}
                />
              )}
              <div className="wrapper">
                {props.fields.BaseImage?.value?.src && (
                  <div className="mobile">
                    <div className="img-container">
                      <Image field={props.fields.BaseImage} />
                    </div>
                  </div>
                )}
                <div className="links list-fade-in-anim animated" ref={animRef}>
                  {props.fields?.BaseLinks &&
                    props.fields?.BaseLinks?.map((item, index) => (
                    <Link
                          className="link-button"
                          field={item.fields.BaseURL}
                          key={index}
                        >
                          {item.fields.BaseURL?.value?.text ||
                            item.fields.BaseURL?.value?.title}

                      </Link>
                    ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LinkList;
